module.exports = require("../export-contract.js")(
  require("../patterns/en-us.js")
);
